import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptCarouselBanners } from "../../adapters/adaptCarouselBanners";

const fetchActiveBanners = async () => {
	const response = await cmsClient.get<IBanner[]>(
		"/homepage/admin/carouselbanner/",
		{
			params: {
				published: true,
			},
		}
	);

	return response.data;
};

interface Options {
	onSuccess?: (banners: Banner[]) => void;
}

const useActiveBanners = (options: Options = {}) => {
	const query = useQuery(["active-banners"], fetchActiveBanners, {
		select: adaptCarouselBanners,
		...options,
	});

	return query;
};

export default useActiveBanners;
